import React, { FC } from 'react';
import translate from '@translate';
import { ReloadIcon } from 'src/components/SkladonIcon/Icons';
import WebhooksSettingsTopBlock from '../SettingsContainer/WebhooksSettingsTopBlock';

type TopBlockProps = {
    reloadHistory: () => void;
};

const TopBlock: FC<TopBlockProps> = (props) => {
    return (
        <WebhooksSettingsTopBlock
            actions={[
                {
                    onClick: props.reloadHistory,
                    icon: <ReloadIcon />,
                    tooltip: translate('webhookHistory.action.synchronize'),
                    variant: 'outlined',
                },
            ]}
        />
    );
};

export default TopBlock;
